import { createContext } from 'react';

export const ModalContext = createContext<{
  modalElement: HTMLElement | null;
  onClose?: () => void;
}>({ modalElement: null });
